module.exports = __webpack_public_path__ + "img/reviewing.0a8a356f.png";